import { render, staticRenderFns } from "./PayPlansTable.vue?vue&type=template&id=f8dfc6b2&scoped=true"
import script from "./PayPlansTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PayPlansTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayPlansTable.vue?vue&type=style&index=0&id=f8dfc6b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8dfc6b2",
  null
  
)

export default component.exports